"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DateFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reduxForm = require("redux-form");

var _reactRedux = require("react-redux");

var _moment = _interopRequireDefault(require("moment"));

var _keyHelpers = require("../../utils/keyHelpers");

var _formatDate = _interopRequireDefault(require("../../utils/formatDate"));

var _FieldLabel = _interopRequireDefault(require("../../ui/FieldLabel"));

var _AgeIndicator = require("./AgeIndicator");

var _types = require("../../types");

var _dateConfig = require("./dateConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var DateDefinition = _flowRuntime["default"].tdz(function () {
  return _dateConfig.DateDefinition;
});

var HTMLSelectEvent = _flowRuntime["default"].tdz(function () {
  return _types.HTMLSelectEvent;
});

var InputStyle = _flowRuntime["default"].tdz(function () {
  return _types.InputStyle;
});

var FieldProps = _flowRuntime["default"].tdz(function () {
  return _reduxForm.FieldProps;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("date", _flowRuntime["default"].ref(DateDefinition)), _flowRuntime["default"].property("error", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("dayValue", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("inputStyle", _flowRuntime["default"].ref(InputStyle)), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("monthValue", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("yearValue", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("day", _flowRuntime["default"].object()), _flowRuntime["default"].property("month", _flowRuntime["default"].object()), _flowRuntime["default"].property("year", _flowRuntime["default"].object())));

var RenderProps = _flowRuntime["default"].type("RenderProps", _flowRuntime["default"].intersection(Props, _flowRuntime["default"].ref(FieldProps)));

var State = _flowRuntime["default"].type("State", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("dateDay", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("dateMonth", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("dateYear", _flowRuntime["default"].string(), true)));

var DateFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DateFields, _React$Component);

  var _super = (0, _createSuper2["default"])(DateFields);

  function DateFields(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, DateFields);
    _this = _super.call(this, props);

    _this.isInvalidLength = function (valueLength, maxLength) {
      return valueLength > maxLength;
    };

    _this.dayChange = function (e) {
      var value = e.target.value;
      var maxLength = _this.props.day.maxLength;

      if (_this.isInvalidLength(value.length, maxLength)) {
        return;
      }

      _this.setState({
        dateDay: value
      });
    };

    _this.monthChange = function (e) {
      var value = e.target.value;
      var maxLength = _this.props.month.maxLength;

      if (_this.isInvalidLength(value.length, maxLength)) {
        return;
      }

      _this.setState({
        dateMonth: value
      });
    };

    _this.yearChange = function (e) {
      var value = e.target.value;
      var maxLength = _this.props.year.maxLength;

      if (_this.isInvalidLength(value.length, maxLength)) {
        return;
      }

      _this.setState({
        dateYear: value
      });
    };

    var _this$props = _this.props,
        dayValue = _this$props.dayValue,
        monthValue = _this$props.monthValue,
        yearValue = _this$props.yearValue;
    _this.state = {
      dateDay: dayValue || '',
      dateMonth: monthValue || '',
      dateYear: yearValue || ''
    };
    return _this;
  }

  (0, _createClass2["default"])(DateFields, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$input = this.props.input,
          onChange = _this$props$input.onChange,
          onBlur = _this$props$input.onBlur;
      var _this$state = this.state,
          dateDay = _this$state.dateDay,
          dateMonth = _this$state.dateMonth,
          dateYear = _this$state.dateYear;

      if (prevState.dateDay !== dateDay || prevState.dateMonth !== dateMonth || prevState.dateYear !== dateYear) {
        if (dateDay && dateMonth && dateYear && dateYear.length === 4) {
          onChange( // format date to allow single digit day and month input - eg 1 instead of 01
          (0, _formatDate["default"])("".concat(dateYear, "-").concat(dateMonth, "-").concat(dateDay)));
          onBlur();
        } else {
          onChange('');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          date = _this$props2.date,
          day = _this$props2.day,
          error = _this$props2.error,
          inputStyle = _this$props2.inputStyle,
          isRequired = _this$props2.isRequired,
          month = _this$props2.month,
          year = _this$props2.year;
      var _this$state2 = this.state,
          dateDay = _this$state2.dateDay,
          dateMonth = _this$state2.dateMonth,
          dateYear = _this$state2.dateYear;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement(_FieldLabel["default"], {
        field: date,
        isRequired: isRequired
      }), /*#__PURE__*/_react["default"].createElement("label", {
        className: day.ui.classes,
        htmlFor: "".concat(date.key, ".").concat(day.key)
      }, day.label, /*#__PURE__*/_react["default"].createElement("input", {
        className: inputStyle.inputClass,
        id: "".concat(date.key, ".").concat(day.key),
        inputMode: "numeric",
        min: "0",
        onChange: this.dayChange,
        pattern: "[0-9]*",
        placeholder: day.placeholder,
        type: day.type,
        value: dateDay,
        maxLength: day.maxLength
      })), /*#__PURE__*/_react["default"].createElement("label", {
        className: month.ui.classes,
        htmlFor: "".concat(date.key, ".").concat(month.key)
      }, month.label, /*#__PURE__*/_react["default"].createElement("input", {
        className: inputStyle.inputClass,
        id: "".concat(date.key, ".").concat(month.key),
        inputMode: "numeric",
        min: "0",
        onChange: this.monthChange,
        pattern: "[0-9]*",
        placeholder: month.placeholder,
        type: month.type,
        value: dateMonth
      })), /*#__PURE__*/_react["default"].createElement("label", {
        className: year.ui.classes,
        htmlFor: "".concat(date.key, ".").concat(year.key)
      }, year.label, /*#__PURE__*/_react["default"].createElement("input", {
        className: inputStyle.inputClass,
        id: "".concat(date.key, ".").concat(year.key),
        inputMode: "numeric",
        min: "0",
        onChange: this.yearChange,
        pattern: "[0-9]*",
        placeholder: year.placeholder,
        type: year.type,
        value: dateYear
      })), !error && date && date.validation && date.validation.some(function (rule) {
        return !!rule.age;
      }) && /*#__PURE__*/_react["default"].createElement(_AgeIndicator.AgeIndicator, {
        day: dateDay,
        month: dateMonth,
        year: dateYear
      }));
    }
  }]);
  return DateFields;
}(_react["default"].Component);

exports.DateFields = DateFields;
DateFields.defaultProps = {
  error: undefined,
  dayValue: undefined,
  monthValue: undefined,
  yearValue: undefined
};
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var key = ownProps.date.key,
      parentKey = ownProps.parentKey;
  var componentKey = (0, _keyHelpers.compositeKey)(parentKey, key);
  var dateFromStore = selector(state, componentKey);

  if (dateFromStore) {
    var date = (0, _moment["default"])(dateFromStore, 'YYYY-MM-DD');
    return {
      dayValue: date.format('DD'),
      monthValue: date.format('MM'),
      yearValue: date.format('YYYY')
    };
  }

  return {};
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps)(DateFields);

exports["default"] = _default;